export var PaymentTypesLabel;
(function (PaymentTypesLabel) {
    PaymentTypesLabel["CASH_OR_FINANCE"] = "Cash or Finance";
})(PaymentTypesLabel || (PaymentTypesLabel = {}));
//# sourceMappingURL=PaymentTypesLabel.js.map